import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api.base.service';
import { environment } from '@env/environment.local';
import { Observable } from 'rxjs';
import { queryParmsDealer } from '../../../model.models';
@Injectable({
    providedIn: 'root'
})
export class DealerTemplateService {

    constructor(public api: ApiService) {
    }    
  /*
  getWholesales(): Observable<any> {
    return this.api.get(`${environment.API_WHOLESALE_SERVICE}/wholesales`);
  }*/
 
  getGroups(): Observable<any> {
      return this.api.get(`${environment.API_DEALEARS_SERVICE}/groups`);
   }

   getDealers(data: queryParmsDealer): Observable<any>{
    return this.api.post(`${environment.API_DEALEARS_SERVICE}/dealers/branches`, data);
   }
}